import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { AlmacenBaseProp, AlmacenOutputProps } from '../interfaces'

const gqlQuery = gql`
  mutation REGISTRO($input: AlmacenInput!) {
    almacenRegistro(input: $input) {
      codigoAlmacen
      nombre
      ubicacion
      sucursal {
        codigo
        direccion
      }
      tipo
      prioridad
      activo
    }
  }
`

export const apiAlmacenRegistro = async (
  input: AlmacenOutputProps,
): Promise<AlmacenBaseProp> => {
  const client = new GraphQLClient(import.meta.env.ISI_API_URL)
  const token = localStorage.getItem(AccessToken)
  // Set a single header
  client.setHeader('authorization', `Bearer ${token}`)
  const data: any = await client.request(gqlQuery, {
    input: input,
  })
  return data.almacenRegistro
}
